import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon UShapeDuotone
 */
export const UShapeDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M32.7,32.7C39.5,32.7,45,38.2,45,45s-5.5,12.3-12.2,12.3S20.5,51.8,20.5,45c0,0,0,0,0,0C20.5,38.2,26,32.8,32.7,32.7  M32.7,22.7c-12.3,0-22.2,10-22.2,22.3s10,22.3,22.2,22.3S55,57.3,55,45S45,22.7,32.7,22.7z"
      fill="currentColor"
    />
    <path
      d="M32.7,89.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C20.5,95.2,26,89.8,32.7,89.7 M32.7,79.7c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2S55,114.3,55,102S45,79.7,32.7,79.7z"
      fill="currentColor"
    />
    <path
      d="M32.7,146.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C20.5,152.2,26,146.8,32.7,146.7 M32.7,136.7c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2S55,171.3,55,159l0,0 C55,146.7,45,136.7,32.7,136.7z"
      fill="currentColor"
    />
    <path
      d="M102,210c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2c0,0,0,0,0,0C89.8,215.5,95.2,210,102,210  M102,200c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3s22.3-10,22.3-22.2c0,0,0,0,0,0C124.2,210,114.3,200,102,200z"
      fill="currentColor"
    />
    <path
      d="M163,210c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.2c0,0,0,0,0,0 C150.8,215.5,156.2,210,163,210 M163,200c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3c12.3,0,22.3-10,22.3-22.2c0,0,0,0,0,0 C185.2,210,175.3,200,163,200z"
      fill="currentColor"
    />
    <path
      d="M223.3,32.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2C211,38.2,216.5,32.8,223.3,32.7  M223.3,22.7C211,22.7,201,32.7,201,45s10,22.3,22.2,22.3s22.2-10,22.2-22.3S235.5,22.7,223.3,22.7z"
      fill="currentColor"
    />
    <path
      d="M223.3,89.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2C211,95.2,216.5,89.8,223.3,89.7  M223.3,79.7c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S235.5,79.7,223.3,79.7z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M223.3,89.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2 C211,95.2,216.5,89.8,223.3,89.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M223.3,32.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2 C211,38.2,216.5,32.8,223.3,32.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M223.3,146.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2 C211,152.2,216.5,146.8,223.3,146.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M163,210c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C150.8,215.5,156.2,210,163,210"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M102,210c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C89.8,215.5,95.2,210,102,210"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M32.7,146.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C20.5,152.2,26,146.8,32.7,146.7 "
      fill="currentColor"
    />
    <path
      className="st0"
      d="M32.7,89.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C20.5,95.2,26,89.8,32.7,89.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M32.8,32.7C39.5,32.7,45,38.2,45,45s-5.5,12.2-12.2,12.2S20.5,51.8,20.5,45C20.5,38.2,26,32.8,32.8,32.7"
      fill="currentColor"
    />
    <path
      d="M223.3,146.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2c-6.8,0-12.2-5.5-12.2-12.2l0,0 C211,152.2,216.5,146.8,223.3,146.7 M223.3,136.7c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C245.5,146.7,235.5,136.7,223.3,136.7z"
      fill="currentColor"
    />
    <path
      d="M181.5,21.5v159h-107v-159h23v136h61v-136L181.5,21.5 M191.5,11.5h-43v136h-41v-136h-43v179h127v-43l0,0V11.5z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M181.5,21.5v159h-107v-159h23v136h61v-136L181.5,21.5"
      fill="currentColor"
    />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default UShapeDuotone;
